import React, { useContext } from 'react';
import { Theme } from '@core-ui/react-stitch/types';
import catPriceAdapter from '@core-ui/price-case/adapters/category-price';
import CPGrid from '@cat/grid';
import AutoScroll from '@cat/autoscroll';
import { XLARGE, LARGE, MEDIUM, SMALL } from '@core-ui/breakpoint-provider';
import { PageDataContext } from '../../providers/page-data-provider';
import { useClpState } from '../../providers/app-state-provider';
import { CLPProductCard } from '../product-card';
import { useBRRedesign } from '../../hooks/br-redesign.hook';


export const ComposableProductGrid = () => {
  const { brand, locale, theme } = useClpState();
  const { productGroups } = useContext(PageDataContext);
  const totalItemCount = productGroups[0].products.length;
  const isBRRedesignEnabled = useBRRedesign();
  const getGridColumns = () => {
    const XXLARGE = !isBRRedesignEnabled && { 1280: 4 };
    return {
      ...XXLARGE,
      [XLARGE]: 3,
      [LARGE]: 3,
      [MEDIUM]: 2,
      [SMALL]: 2,
    };
  };

  const gridColumns = getGridColumns();

  return (
    <div
      className="composable-product-grid"
      data-testid="composable-product-grid"
    >
      <AutoScroll cid={productGroups[0].cid}>
        <CPGrid
          key={0}
          index={0}
          data={productGroups[0].products}
          contents={{
            default: (product, index) => (
              <CLPProductCard
                productInfo={{
                  name: product.name,
                  productID: product.productID,
                  ...product,
                }}
                brand={brand}
                cardIndex={index}
                groupIndex={0}
                locale={locale}
                pageIndex={'0'}
                priceAdapter={catPriceAdapter}
                productGridSource={'Bloomreach'}
                totalCount={totalItemCount}
              />
            ),
          }}
          columns={gridColumns}
          spacing={isBRRedesignEnabled ? 0 : 0.5}
          theme={(theme as unknown as Theme)}
        />
      </AutoScroll>
    </div>
  );
};

export default ComposableProductGrid;
